import React from 'react';
import SearchHealthCenters from '../components/SearchHealthCenters';

const Search: React.FC = () => {
  return (
    <SearchHealthCenters />
  );
};

export default Search;